import { render, staticRenderFns } from "./InboxWindowTextarea.vue?vue&type=template&id=7b39d232"
import script from "./InboxWindowTextarea.vue?vue&type=script&lang=ts"
export * from "./InboxWindowTextarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b39d232')) {
      api.createRecord('7b39d232', component.options)
    } else {
      api.reload('7b39d232', component.options)
    }
    module.hot.accept("./InboxWindowTextarea.vue?vue&type=template&id=7b39d232", function () {
      api.rerender('7b39d232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowTextarea.vue"
export default component.exports